import axios from "axios";
import { clearSession } from "../utils/session";

// Base URL
const API = axios.create({
    baseURL: 'https://api.antipsun.com/api/',
    timeout: 30000,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
    },
});

// Request Interceptor
API.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token");

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => Promise.reject(error)
);

// Response Interceptor — clear full session on 401 (except for public auth endpoints)
API.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            const requestUrl = error.config?.url || "";
            const isAuthEndpoint =
                requestUrl.includes("password-reset") ||
                requestUrl.includes("verify-email") ||
                requestUrl.includes("login") ||
                requestUrl.includes("register");

            if (!isAuthEndpoint) {
                clearSession();
                window.location.href = "/login";
            }
        }

        return Promise.reject(error);
    }
);

// GET
export const getApi = (url, params = {}, config = {}) =>
    API.get(url, { params, ...config });

// POST
export const postApi = (url, data = {}, config = {}) =>
    API.post(url, data, config);

// PUT
export const putApi = (url, data = {}, config = {}) =>
    API.put(url, data, config);

// PATCH
export const patchApi = (url, data = {}, config = {}) =>
    API.patch(url, data, config);

// DELETE
export const deleteApi = (url, config = {}) =>
    API.delete(url, config);

export default API;